module.exports = __webpack_public_path__ + "img/colossus.b1f60118.webp";